// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lang-btn[data-v-68d28978]{width:80%;max-width:300px;min-height:44px}.lang-selector-mobile .lang-selector-mobile-list[data-v-68d28978]{overflow:auto;justify-content:flex-start;margin:3em 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
